import { amICoachingClientOptions } from "@/actions/client-metrics/handler";
import { ClientCoachingDashboard } from "@/components/coaching/ClientCoachingDashboard";
import { Skeleton } from "@/components/ui/skeleton";
import { seo } from "@/utils/seo";
import { createFileRoute, isRedirect, redirect } from "@tanstack/react-router";
import { Suspense } from "react";

export const Route = createFileRoute("/_app/coaching/")({
  head: () => ({
    meta: seo({
      title: "Kocluk Takibi | AtalayTheCoach",
      description: "Gunluk hedeflerinizi takip edin ve gelisiminizi kaydedin.",
    }),
  }),
  beforeLoad: async ({ context }) => {
    if (!context.user) {
      throw redirect({ to: "/password/login" });
    }

    try {
      const coachingData = await context.queryClient.ensureQueryData(
        amICoachingClientOptions(),
      );

      if (!coachingData.body?.isCoachingClient) {
        throw redirect({ to: "/coachs" });
      }
    } catch (e: unknown) {
      if (isRedirect(e)) {
        throw e;
      }
      if (e instanceof Error && e.message === "Unauthorized") {
        throw redirect({ to: "/password/login" });
      }
      throw e;
    }
  },
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(amICoachingClientOptions());
  },
  component: CoachingPage,
});

function CoachingPage() {
  return (
    <div className="container mx-auto max-w-2xl px-4 pt-24 pb-20">
      <Suspense fallback={<CoachingSkeleton />}>
        <ClientCoachingDashboard />
      </Suspense>
    </div>
  );
}

function CoachingSkeleton() {
  return (
    <div className="space-y-4">
      {/* Date strip */}
      <div className="flex gap-1.5 overflow-hidden">
        {[1, 2, 3, 4, 5, 6, 7].map((i) => (
          <Skeleton key={i} className="h-14 w-[50px] shrink-0 rounded-xl" />
        ))}
      </div>
      {/* Status pill */}
      <Skeleton className="h-7 w-32 rounded-full" />
      {/* Primary Grid Skeleton */}
      <div className="grid grid-cols-2 gap-2">
        <Skeleton className="h-20 rounded-xl" />
        <Skeleton className="h-20 rounded-xl" />
      </div>
      {/* Macro Grid Skeleton */}
      <div className="grid grid-cols-3 gap-2">
        <Skeleton className="h-16 rounded-xl" />
        <Skeleton className="h-16 rounded-xl" />
        <Skeleton className="h-16 rounded-xl" />
      </div>
      {/* Others Grid Skeleton */}
      <div className="grid grid-cols-2 gap-2">
        <Skeleton className="h-16 rounded-xl" />
        <Skeleton className="h-16 rounded-xl" />
      </div>
      <Skeleton className="h-[160px] w-full rounded-xl" />
      {/* FAB */}
      <Skeleton className="h-12 w-full rounded-2xl" />
    </div>
  );
}
